import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const environment = process.env.REACT_APP_ENVIRONMENT || 'production';
const isTestEnvironment = environment === 'test';

const getEnvVar = (prodKey: string, testKey: string): string | undefined => {
  return isTestEnvironment
    ? process.env[testKey] || process.env[prodKey]
    : process.env[prodKey];
};

const requiredEnvVars = {
  apiKey: getEnvVar('REACT_APP_FIREBASE_API_KEY', 'REACT_APP_FIREBASE_TEST_API_KEY'),
  authDomain: getEnvVar('REACT_APP_FIREBASE_AUTH_DOMAIN', 'REACT_APP_FIREBASE_TEST_AUTH_DOMAIN'),
  databaseURL: getEnvVar('REACT_APP_FIREBASE_DATABASE_URL', 'REACT_APP_FIREBASE_TEST_DATABASE_URL'),
  projectId: getEnvVar('REACT_APP_FIREBASE_PROJECT_ID', 'REACT_APP_FIREBASE_TEST_PROJECT_ID'),
  storageBucket: getEnvVar('REACT_APP_FIREBASE_STORAGE_BUCKET', 'REACT_APP_FIREBASE_TEST_STORAGE_BUCKET'),
  messagingSenderId: getEnvVar('REACT_APP_FIREBASE_MESSAGING_SENDER_ID', 'REACT_APP_FIREBASE_TEST_MESSAGING_SENDER_ID'),
  appId: getEnvVar('REACT_APP_FIREBASE_APP_ID', 'REACT_APP_FIREBASE_TEST_APP_ID'),
  measurementId: getEnvVar('REACT_APP_FIREBASE_MEASUREMENT_ID', 'REACT_APP_FIREBASE_TEST_MEASUREMENT_ID')
};

const missingVars = Object.entries(requiredEnvVars)
  .filter(([key, value]) => !value && key !== 'measurementId')
  .map(([key]) => key);

if (missingVars.length > 0) {
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment) {
    console.warn(`Ambiente: ${environment.toUpperCase()} - Variáveis faltando: ${missingVars.join(', ')}`);
  } else {
    throw new Error(`Configuração Firebase incompleta para ${environment}. Faltam: ${missingVars.join(', ')}`);
  }
}

if (process.env.NODE_ENV === 'development') {
  console.log(`Firebase: ${environment.toUpperCase()} | Project: ${requiredEnvVars.projectId}`);
}

const firebaseConfig = {
  apiKey: requiredEnvVars.apiKey!,
  authDomain: requiredEnvVars.authDomain!,
  databaseURL: requiredEnvVars.databaseURL!,
  projectId: requiredEnvVars.projectId!,
  storageBucket: requiredEnvVars.storageBucket!,
  messagingSenderId: requiredEnvVars.messagingSenderId!,
  appId: requiredEnvVars.appId!,
  measurementId: requiredEnvVars.measurementId
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);

setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Erro ao configurar persistência:', error);
});

export default app;

